<template>
    <div>
        <div class="container">
            <div class="titleBar">
                <span class="mgl20">{{$t('CreatePage.createUser')}}</span>                        
                <el-button class="rightButton" @click="goBack">{{$t('CreatePage.backButton')}}</el-button>
            </div>           
                       
            <el-form class="form-box" :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px">
                <input name="text1" style="position: absolute;left: -10000px;top: -10000px;"/>
                <input type="password" name="password1" style="position: absolute;left: -10000px;top: -10000px;"/>                
                <div class="formTitle">
                    <span>{{$t('CreatePage.baseInfo')}}</span>                        
                </div>                     
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.company')" prop="company">                           
                            <el-input v-model="ruleForm.company" class="formWidth"></el-input>     
                        </el-form-item>                          
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.userName')" prop="userName">
                            <el-input v-model="ruleForm.userName" class="formWidth"></el-input>                            
                        </el-form-item>  
                    </el-col>    
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.userPass')" prop="userPass">
                            <el-input v-model="ruleForm.userPass" class="formWidth" show-password></el-input>                            
                        </el-form-item>  
                    </el-col>                                    
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.userEmail')" prop="userEmail">
                            <el-input v-model="ruleForm.userEmail" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.contact')" prop="contact">
                            <el-input v-model="ruleForm.contact" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.phone')" prop="phone">
                            <el-input v-model="ruleForm.phone" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>                    
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item :label="$t('UserManage.remark')" prop="remark">
                            <el-input v-model="ruleForm.remark" style="width: 93.5%"></el-input>
                        </el-form-item>
                    </el-col>                 
                </el-row>

                <div class="formTitle">
                    <span>{{$t('CreatePage.permission')}}</span>                        
                </div>  

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.taskManage.all" @change="taskManagePer">{{$t('UserManage.taskPer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.taskManage.add" class="perblock mb10 mt10">{{$t('UserManage.taskPer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.taskManage.edit" class="perblock mb10">{{$t('UserManage.taskPer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.taskManage.delete" class="perblock mb10">{{$t('UserManage.taskPer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.deviceManage.all" @change="deviceManagePer">{{$t('UserManage.devicePer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.deviceManage.import" class="perblock mb10 mt10">{{$t('UserManage.devicePer.import')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.add" class="perblock mb10 mt10">{{$t('UserManage.devicePer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.move" class="perblock mb10 mt10">{{$t('UserManage.devicePer.move')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.edit" class="perblock mb10">{{$t('UserManage.devicePer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.delete" class="perblock mb10">{{$t('UserManage.devicePer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>             

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.groupManage.all" @change="groupManagePer">{{$t('UserManage.groupPer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.groupManage.add" class="perblock mb10 mt10">{{$t('UserManage.groupPer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.groupManage.move" class="perblock mb10 mt10">{{$t('UserManage.groupPer.move')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.groupManage.edit" class="perblock mb10">{{$t('UserManage.groupPer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.groupManage.delete" class="perblock mb10">{{$t('UserManage.groupPer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>     

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.fileMenu.all" @change="fileMenuPer">{{$t('UserManage.filePer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.fileMenu.add" class="perblock mb10 mt10">{{$t('UserManage.filePer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.fileMenu.edit" class="perblock mb10">{{$t('UserManage.filePer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.fileMenu.delete" class="perblock mb10">{{$t('UserManage.filePer.delete')}}</el-checkbox>
                    </el-col>
                </el-row> 

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.userManage.all" @change="userManagePer">{{$t('UserManage.userPer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.userManage.add" class="perblock mb10 mt10">{{$t('UserManage.userPer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.userManage.edit" class="perblock mb10">{{$t('UserManage.userPer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.userManage.delete" class="perblock mb10">{{$t('UserManage.userPer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>   

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.noticeManage.all" @change="noticeManagePer">{{$t('UserManage.noticePer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <!-- <el-checkbox v-model="permissions.noticeManage.add" class="perblock mb10 mt10">{{$t('UserManage.noticePer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.noticeManage.edit" class="perblock mb10">{{$t('UserManage.noticePer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.noticeManage.delete" class="perblock mb10">{{$t('UserManage.noticePer.delete')}}</el-checkbox> -->
                        <el-checkbox v-model="permissions.noticeManage.search" class="perblock mb10 mt10">{{$t('UserManage.noticePer.view')}}</el-checkbox>
                    </el-col>
                </el-row>                 
                <el-form-item class="buttonCenter">
                    <el-button type="primary" @click="onSubmit('ruleForm')">{{$t('Button.submit')}}</el-button>
                    <el-button @click="goBack">{{$t('Button.back')}}</el-button>
                </el-form-item>                   
            </el-form> 

        </div>


    </div>
</template>

<script>
import bus from '../../common/bus';
import Tools from '../../common/Tools';
import api from '../../../api/api.js';
import apiAllSystem from '../../../api/apiAllSystem.js';

export default {
    name: 'taskCreate',
    components: { 

    },     
    data() {
        return {
            labelPosition: "top",
            pagesize: 10, //每页显示条数
            curPage: 1,   //当前页数         
            multipleSelection: [],
            ruleForm: {
                company: "",
                userName: "",
                userPass: "",
                userEmail: "",
                contact: "",
                phone: "",
                remark: ""
            },
            companySelect: [],
            tableData: [],
            permissions: {
                taskManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                deviceManage: { all: false, add: true, edit: true, delete: true, move: true, export: true, import: false },
                groupManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                fileMenu: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                userManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                noticeManage: { all: true, add: false, edit: false, delete: false, move: false, export: false, import: false, search: true },
            }
        }
    },
    
    computed: {
        rules() {
            return {
                company: [
                    // { required: true, pattern: '[^ \x22]+', message: this.$t('Rules.require'), trigger: 'blur'},
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: "string", pattern: /^[\u4E00-\u9FA5a-zA-Z0-9]+([_-][\u4E00-\u9FA5a-zA-Z0-9]+)*$/, min: 2, max: 20, message: this.$t('Rules.name'), trigger: 'blur'},
                ],
                userName: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},                    
                    { type: "string", pattern: /^[a-zA-Z0-9_-]+$/, min: 3, max: 20, message: this.$t('Rules.userName'), trigger: 'blur'},
                ],
                userPass: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: "string", pattern: /^[a-zA-Z0-9~!@#$%^&*()_+-=]+$/, min: 6, max: 20, message: this.$t('Rules.userPass'), trigger: 'blur'},
                    // { type: "string", pattern: /(?=.*([a-zA-Z].*))(?=.*[0-9].*)[a-zA-Z0-9~!@#$%^&*()_+-=]{6,20}$/, message: '请输入长度6到20位的数字、字母和特殊字符，至少包含数字和字母', trigger: 'blur'},
                ],
                userEmail: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: 'email', message: this.$t('Rules.userEmail'), trigger: 'blur' }
                ],      
                phone: [
                    { type: "string", pattern: /^[+]?[0-9()]+([\s-][0-9()]+)*$/, min: 6, max: 20, message: this.$t('Rules.phone'), trigger: 'blur'},
                ],                                    
            }
        }
    },
    created() {
        // this.getData();
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },      

        getData() {
            let basePer = {
                all: true,
                add: true,
                edit: true,
                delete: true,
                move: true,
                export: true,
                import: false
            }

            this.permissions = {
                taskManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                deviceManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                groupManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                fileMenu: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                userManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                noticeManage: { all: false, add: false, edit: false, delete: false, move: false, export: false, import: false, search:true },
            }
        },

        taskManagePer(val){
            if(val == true) { this.permissions.taskManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.taskManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },

        deviceManagePer(val){
            if(val == true) { this.permissions.deviceManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.deviceManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },

        groupManagePer(val){
            if(val == true) { this.permissions.groupManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.groupManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },

        fileMenuPer(val){
            if(val == true) { this.permissions.fileMenu = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.fileMenu = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },
        
        userManagePer(val){
            if(val == true) { this.permissions.userManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.userManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },
        
        noticeManagePer(val){
            if(val == true) { this.permissions.noticeManage = {add: true, edit: true, delete: true, move: true, export: true, import: true, search: true}; } 
            else { this.permissions.noticeManage = {add: false, edit: false, delete: false, move: false, export: false, import: false, search: false}; }
        },       

        onSubmit(formName) {     
            this.$refs[formName].validate((valid) => {
                if (valid) {     
                    let params = {
                        fathersssid: localStorage.getItem('sssid'),
                        password: this.ruleForm.userPass
                    };
                    let bodyParams = {
                        user: {
                            nickname: this.ruleForm.company,
                            account: this.ruleForm.userName,
                            email: this.ruleForm.userEmail,
                            contact: this.ruleForm.contact,
                            cellphone: this.ruleForm.phone,
                            remark: this.ruleForm.remark
                        },
                        fotapermission: {
                            TaskPermission: this.permissions.taskManage,
                            TrackerPermission: this.permissions.deviceManage,
                            TrackerGroupPermission: this.permissions.groupManage,
                            FilePermission: this.permissions.fileMenu,
                            UserPermission: this.permissions.userManage,
                            MessagePermission: this.permissions.noticeManage,
                        }

                    };                 
                    api.createUserWithPer(params, bodyParams)
                    .then(res => {
                        if(res.state){
                            this.$message.success(this.$t('Message.success'));
                            this.$router.push({path:'/userManage', query:{detail: res.value.text}});
                        } else {
                            this.$message.error(res.value.text);
                        }
                        
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('Message.reqError'));
                    });  
                }
            })                                                  
 
        },
        

    }
};
</script>

<style scoped>
.perBox {
    display: flex;
    align-items: center
}
.perUnderLine {
    border-bottom: 1px solid #E9E9E9;
}
.perblock {
    display:block
}
</style>